/* GROUP */
export const GET_GROUP = "GET_GROUP"
export const GET_GROUP_SUCCESS = "GET_GROUP_SUCCESS"
export const GET_GROUP_CLEAN = "GET_GROUP_CLEAN"
export const API_ERROR = "API_ERROR"
